import React from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import Header from "../../component/common/Header";
import ModalWindow from "../../component/common/ModalWindow";
import AddComment from "../../component/file/AddComment";
import Loader from "../../component/common/Loader";
import CONSTANT from "../../constant";
import Shimmer from "../../component/common/Shimmer";
import './../../assets/css/CommentModel.css'

import {

  getFileDetail,
  reOpenFile,
  reCallFile,
  getFileTimeLine,
} from "../../actions/FileAction";



import {
  getCommentList,
  addComment,
  uploadAttachment,
} from "../../actions/CommentAction";
import { getDateParts, getCookie, getStorage } from "../../utils";
import { CommandBarButton } from "@fluentui/react/lib/Button";
import FileTimeline from "../../component/file/FileTimeline";
import { debug } from "console";
import CommentModel from "../../component/commentmodel/CommentModel";




class ParkedFileReferenceDetails extends React.Component<any, any> {


  constructor(props: any) {
    super(props);
    this.state = {
      code: props.fileCode,
      ud: getCookie(CONSTANT.cookie.userDetail),
      permissions: getStorage(CONSTANT.cookie.permissions),
      detail: undefined,
      comments: undefined,
      showAddComment: false,
      showLoader: false,
      showTimeLineModal: false,
      timeLineDetails: null,

    };
  }





  componentDidMount() {

    window.scrollTo(0, 0);
    document.title = CONSTANT.pageTitle.fileDetail;
    const { code } = this.state;

    getCommentList(code).then((res: any) => {
      this.setState({ comments: res.result });
    });

    getFileDetail(code).then((res: any) => {
      if (res.error) {
        alert(res.error);
      } else {



        const { ud, permissions } = this.state;
        const { cc, pendingWith } = res.result;
        let hasAccess =
          pendingWith.find((item: any) => item.userCode === ud.code) ||
          permissions.includes(CONSTANT.static.permissions.fileAdminAccess) ||
          cc.some((item: any) => item.code === ud.code);
        this.setState({ detail: res.result });
        getCommentList(code).then((res: any) => {
          this.setState({ comments: res.result });
        });
      }
    });
  }
  render() {
    const { detail, comments } = this.state;
    const { showAddComment, showLoader, ud } = this.state;


    let showAddCommentButton = false;

    if (detail) {

      showAddCommentButton = detail.pendingWith.find((item: any) => item.userCode === ud.code);
      showAddCommentButton = showAddCommentButton && detail.detail.isClosed === false;
    }

    return (

      <div className="container-fluid">

        <div className="row">

          <div className="col-md-12">
            <div className="row my-3">
              <div className="col-md-8">
                <h1 className="page-title"> File detail</h1>
              </div>
              <div className="col-md-4">
                <Link
                  to={CONSTANT.component.userFileList.url}
                  className="btn btn-sm btn-link float-right"
                >
                  Go Back
                </Link>
                <button
                  onClick={this.onPrint}
                  className="btn btn-sm btn-link float-right"
                >
                  <i className="fa fa-print" /> Print
                </button>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                {detail === undefined && <Shimmer />}
                {detail !== undefined && this.renderDetail()}
                {detail !== undefined &&
                  comments !== undefined &&
                  this.renderComments()}
                {detail !== undefined && this.renderFileClosedSection()}
                {detail !== undefined && this.renderRecallFileSection()}
              </div>
            </div>
          </div>
        </div>
        {showLoader && <Loader />}




        {/* {
detail!=undefined && detail.detail.code==10914?
<>
<ModalWindow
            title="Add comment"
            backdrop="static"
            className="modal-lg"
            toggleModal={this.toggleAddComment}
          >

            <AddComment
              nextlevelReviewers={detail.nextlevelReviewers}
              pendingWith={detail.pendingWith}
              detail={detail.detail}
              approver={detail.approvers}
              onSubmit={this.onAddComment}
              toggleModal={this.toggleAddComment}
            />

          </ModalWindow> 
          <button
            className="comment-button bg-primary text-white btn btn-sm"
            onClick={this.toggleAddComment}
          >
            Add Comment
          </button>
          </>
          
          :""  
} */}


        {showAddComment && (

          <CommentModel
            title="Add comment"
            backdrop="static"
            className="modal-lg"
          >

            <AddComment
              nextlevelReviewers={detail.nextlevelReviewers}
              pendingWith={detail.pendingWith}
              detail={detail.detail}
              approver={detail.approvers}
              onSubmit={this.onAddComment}
              toggleModal={this.toggleAddComment}
            />

          </CommentModel>
        )}



        {
          showAddCommentButton && (
            <React.Fragment>
              {
                <>

                  <button
                    className="comment-button   bg-primary text-white " id="openModalBtn"
                    onClick={this.toggleAddComment}
                    style={{
                      width: "150px",
                      height: "30px",
                      display: "inline-flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "10px",
                      // background: "rgb(64,116,121)", 
                      background: "linear-gradient(333deg, rgba(64,116,121,1) 0%, rgba(24,86,89,1) 7%, rgba(52,128,129,1) 29%, rgba(52,59,59,1) 100%)"
                    }}
                  >   Add Comment   </button>
                </>
              }

            </React.Fragment>
          )}


      </div>
    );

  }

  renderDetail = () => {
    const { detail } = this.state;
    const fileDated = getDateParts(detail.detail.dated);
    const createdOn = getDateParts(detail.detail.createdOn);
    const { referenceFiles } = detail.detail;

    return (
      <React.Fragment>
        <div className="card main-file mb-3" id={`file-${detail.detail.code}`}>
          <div className="card-body">
            <div className="row">
              <div className="col-md-12 text-center">
                <div>(1)</div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                No: {detail.detail.fileNumber}
                <span className="float-right">
                  {`${fileDated.date} ${fileDated.monthName} ${fileDated.year}`}
                </span>
              </div>

              <div className="col-md-12 mt-3">
                <strong className="">Subject: {detail.detail.subject}</strong>
              </div>

              <div className="col-md-12 mt-3 text-justify">
                <div

                  dangerouslySetInnerHTML={{
                    __html: detail.detail.body.replace(
                      /(?:\r\n|\r|\n)/g,
                      "<br>"
                    ),
                  }}
                />
              </div>

              <div className="col-md-12 mt-3 text-right">
                <span className="fs-12">
                  {detail.detail.employeeName}
                  <br />
                  {detail.detail.createdByDesignation}
                  <br />
                  {`${createdOn.date} ${createdOn.monthName} ${createdOn.year} ${createdOn.hour}:${createdOn.minute}:${createdOn.seconds} ${createdOn.amOrpm}`}
                </span>
              </div>
            </div>
          </div>

          {/* file attachment section  */}
          <div >

            {detail.attachments.length > 0 && (

              <div className="card-footer no-print printFile">
                <div className="row">
                  <div className="col-md-12 no-print">
                    <span className="mr-3">Attachment(s)</span>

                    {detail.attachments
                      .filter((i: any) => i.commentCode === null)
                      .map(function (item: any, index: number) {
                        const downloadURL =
                          `${process.env.REACT_APP_BASE_URL}attachment/${item.fileCode}/${item.fileName}`.replace(
                            "v1/",
                            ""
                          );
                        return (
                          <>
                            <a
                              href={downloadURL}
                              target="_blank"
                              key={index}
                              className="badge badge-primary mr-1 p-2" >

                              <i className="fa fa-arrow-circle-o-down" />
                              {item.originalFileName}
                            </a>
                          </>

                        );
                      })}
                  </div>
                </div>
              </div>
            )}

          </div>


          { /*  file attachment section */}


          {referenceFiles && referenceFiles.length > 0 && (
            <div className="card-footer no-print printFile ">
              <div className="row">
                <div className="col-md-12 no-print">
                  <span className="mr-3">Reference File(s)</span>
                  {referenceFiles.map(function (item: any, index: number) {
                    const downloadURL =
                      `${process.env.REACT_APP_BASE_URL}attachment/${item.fileCode}/${item.fileName}`.replace(
                        "v1/",
                        ""
                      );

                    return (
                      <a
                        href={downloadURL}
                        target="_blank"
                        key={index}
                        className="badge badge-primary mr-1 p-2"
                      >
                        <i className="fa fa-arrow-circle-o-down" />
                        {item.originalFileName}
                      </a>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
        </div>


        {detail !== undefined &&
          (detail.department.length > 0 ||
            detail.detail.financialImplication ||
            detail.approvers.length > 0) && (
            <div className="card alert-info mb-3 additional_info">

              <div className="card-header">Additional Info</div>
              <div className="card-body">
                <div className="row">
                  {detail.department.length > 0 && (
                    <div className="col">
                      <b>Departments Sequence</b>
                      <br />
                      {detail.department.map(function (
                        dept: any,
                        index: number
                      ) {
                        return (
                          <span
                            key={index}
                            className="badge badge-primary mr-1"
                          >
                            {dept.name}
                          </span>
                        );
                      })}
                    </div>
                  )}
                  {detail.detail.financialImplication && (
                    <div className="col">
                      <b>Financial implication </b>
                      <br />
                      {`${CONSTANT.static.currencySymbol} ${parseFloat(
                        detail.detail.financialImplication
                      ).toLocaleString(CONSTANT.static.locale)}`}
                    </div>
                  )}
                  {detail.approvers.length > 0 && (
                    <div className="col">
                      <b>Approver</b>
                      <br />
                      {detail.approvers
                        .map((item: any) => item.name)
                        .join(", ")}
                    </div>
                  )}
                  {
                    <div className="col">

                      <CommandBarButton
                        onClick={() =>
                          this.setState({ showTimeLineModal: true })
                        }
                        style={{ backgroundColor: "transparent" }}
                        text="View Timeline"
                      />
                    </div>
                  }
                </div>
              </div>
            </div>
          )}

        <FileTimeline
          isOpen={this.state.showTimeLineModal}
          onDismiss={() => this.setState({ showTimeLineModal: false })}
          fetchData={this.fetchFileTimeLine}
          timeLineDetails={this.state.timeLineDetails}

        />

      </React.Fragment>
    );
  };


  renderFileClosedSection = () => {

    const { detail } = this.state;
    const closedOnDt = getDateParts(detail.detail.closedOn);
    const showDiv = detail.detail.isClosed;

    return (
      showDiv && (
        <div className="ms-MessageBar ms-MessageBar--warning">
          <div className="ms-MessageBar-content">
            <div className="ms-MessageBar-icon">
              <i className="ms-Icon ms-Icon--Info"></i>
            </div>
            <div className="ms-MessageBar-text ">
              <p className="font-bold text-success">  {`files have been parked  on ${closedOnDt.date} ${closedOnDt.monthName} ${closedOnDt.year}`} </p>
              <br />

            </div>
          </div></div>
      )
    );
  };




  renderComments = () => {

    const { comments, detail, ud, permissions } = this.state;
    const canReadComments =
      detail.pendingWith.find((item: any) => item.userCode === ud.code) ||
      detail.cc.some((item: any) => item.code === ud.code) ||
      // detail.detail.closedBy === ud.code ||
      // detail.detail.modifiedBy === ud.code ||
      permissions.indexOf(CONSTANT.static.permissions.fileAdminAccess) > -1;

    const renderComments =
      comments &&
      comments.length > 0 &&
      comments.map((item: any, index: number) => {
        const commentDt = getDateParts(item.createdOn);
        const commAttachment = detail.attachments.filter(
          (i: any) => i.commentCode === item.code
        );
        return (
          <div className="card comment-file mb-3" key={index}>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12 text-center">
                  <div>
                    <span>({index + 2})</span>
                  </div>
                </div>
              </div>
              <div className="row">

                <div className="col-md-12">
                  <strong>{item.notingName}</strong>
                </div>

                {item.comment && (
                  <div className="col-md-12 text-justify">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.comment.replace(/(?:\r\n|\r|\n)/g, "<br>"),
                      }}
                    />

                  </div>
                )}
              </div>
              <div className="row mt-3">
                <div className="col-md-6"></div>
                <div className="col-md-6 text-right">
                  <span className="fs-12">
                    {item.employeeName}
                    <br />
                    {item.createdByDesignation}
                    <br />
                    {`${commentDt.date} ${commentDt.monthName} ${commentDt.year} ${commentDt.hour}:${commentDt.minute}:${commentDt.seconds} ${commentDt.amOrpm}`}
                  </span>
                </div>
              </div>
            </div>


            {commAttachment.length > 0 && (
              <div className="card-footer no-print">
                <div className="row">
                  <div className="col-md-12">
                    <span className="mr-3">Attachment(s)</span>

                    {commAttachment.map(function (
                      attachment: any,
                      index2: number
                    ) {
                      const downloadURL =
                        `${process.env.REACT_APP_BASE_URL}attachment/${attachment.fileCode}/${attachment.commentCode}/${attachment.fileName}`.replace(
                          "v1/",
                          ""
                        );
                      return (
                        <>
                          <a
                            href={downloadURL}
                            target="_blank"
                            key={index2}
                            className="badge badge-primary mr-1 p-2"
                          >
                            <i className="fa fa-arrow-circle-o-down" />
                            {attachment.originalFileName}
                          </a>

                        </>
                        // <a href={downloadURL} target="_blank" key={index2} className="badge badge-primary mr-1 p-2"><i className="fa fa-arrow-circle-o-down" />{attachment.fileName}</a>
                      );
                    })}

                  </div>
                </div>
              </div>
            )}
          </div>

        );
      });

    // if (canReadComments) {
    //   return renderComments;
    // } else {
    //   return (
    //     <div className="card comment-file mb-3">
    //       <div className="card-body text-center">
    //         Comments are only visible to the marked person.
    //       </div>
    //     </div>
    //   );
    // }

    return renderComments
  };

  fetchFileTimeLine = async () => {

    const { detail } = this.state;
    const fileCode = detail.detail.code;

    const { result } = await getFileTimeLine(fileCode);
    let timeline = result
    timeline.level = detail.detail.level
    this.setState({ timeLineDetails: timeline });

  };

  renderRecallFileSection = () => {

    const { detail, ud } = this.state;
    const closedOnDt = getDateParts(detail.detail.modifiedOn);
    const showDiv =
      (!detail.detail.isClosed &&
        detail.detail.modifiedBy === ud.code &&
        !detail.pendingWith.some((item: any) => item.code === ud.code)) ||
      detail.previousLevelReviewers.some((item: any) => item.code === ud.code);

    return (
      showDiv && (
        <div className="alert alert-dismissible alert-warning mt-3">
          This file was last modified on{" "}
          <u>{`${closedOnDt.date} ${closedOnDt.monthName} ${closedOnDt.year}`}</u>{" "}
          <a href="javascript:void;" onClick={this.onRecallFile}>
            Click here to re-call this file
          </a>
        </div>
      )
    );
  };



  onAddComment = (model: any, attachments: any) => {

    this.setState({ showLoader: true });

    addComment(model).then(async (res: any) => {
      this.setState({ showLoader: false });
      if (res) {
        if (res.status === CONSTANT.static.apiStatus.success) {
          for (let i = 0; i < attachments.length; i++) {
            const item = attachments[i];
            const itemModel = {
              fileCode: res.result.fileCode,
              commentCode: res.result.code,
              attachment: item,
            };
            await uploadAttachment(itemModel);
          }
          this.props.history.push(CONSTANT.component.userFileList.url);
        } else {
          alert(res.error);
        }
      }
    });

  };





  onFileReOpen = (e: any) => {
    this.setState({ showLoader: true });
    const { code } = this.state;
    reOpenFile({ code }).then((res: any) => {
      this.setState({ showLoader: false });
      if (res) {
        if (res.status === CONSTANT.static.apiStatus.success) {
          this.props.history.push(CONSTANT.component.userFileList.url);
        } else {
          alert(res.error);
        }
      }
    });
  };

  onRecallFile = (e: any) => {

    this.setState({ showLoader: true });
    const { code } = this.state;
    reCallFile({ code }).then((res: any) => {
      this.setState({ showLoader: false });
      if (res) {
        if (res.status === CONSTANT.static.apiStatus.success) {
          this.props.history.push(CONSTANT.component.userFileList.url);
        } else {
          alert(res.error);
        }
      }
    });
  };


  onPrint = (e: any) => {

    const mainSection = $(".main-file");
    const additional_info = $(".additional_info").html();
    const commentSection = $(".comment-file");
    let html = mainSection.html();

    // print file 
    const printFile = $('.printFile')
    let allFilesAttchmentNames = printFile.html();


    for (let i = 0; i < commentSection.length; i++) {
      html = html + commentSection[i].innerHTML
    }



    const style = `
     
        <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css" integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh" crossorigin="anonymous">
        <style type="text/css">
         
        body{
            font-size:16px;
        }

        .card-body{
            border-bottom: 2px dotted gray;
        }
        
        @page{
            size:A4,
            margin-top: 2cm;
            margin-bottom: 2cm;
            margin-left:6cm;
            margin-right:1.5cm;
        }
        @media print {
            body
            {
                font-size:15.5pt;
            }
            .print-btn{
                visibility:hidden;
            }
        }
        </style> ` ;

    let myWindow: any = window.open("", "", "width=800,height=600");

    myWindow.document.write(`${style}
    <button class="print-btn float-right" onclick="window.print()">Print Now</button>
     </div><div class="fluid-container">${html}<br/>
     ${additional_info} <br/>
    <button class="print-btn float-right" onclick="window.print()">Print Now</button></div>
    `);

    myWindow.focus();

  };


  toggleAddComment = () => {

    this.setState({ showAddComment: !this.state.showAddComment });

  };


}





class ExternalScriptComponent extends React.Component {

  componentDidMount() {
    const body = document.querySelector("body");
    const script = document.createElement("script");
    script.setAttribute("src", "./../../../Script.js");
    script.async = true;
    script.type = "text/javascript";
    body?.appendChild(script);

  }

  render() {
    return (
      <React.Fragment>

      </React.Fragment>
    );
  }
}





export default ParkedFileReferenceDetails;
